import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import paymentOptionsConstant from '../../../../../shared/paymentOptionsConstant';
import { LanguageService } from '../../../../../shared/services/language.service';
import { Report, SelectionAction } from '../../../../admin/report/report';

import { SaveEventDataService } from '../../../../admin/report/services/save-event-data.service';
import { SalesReportService } from '../../services/sales-report.service';
import { SalesComponent } from '../sales/sales.component';
import { SendMarketingSmsService } from '../../services/send-marketing-sms.service';
import { FetchAllSellerProductsService } from 'src/app/dashboard/admin/report/services/fetch-all-business-products.service';
import { SellerResendMailService } from 'src/app/dashboard/admin/report/services/seller-resend-mail.service';
import { RefundCreditPaymentService } from 'src/app/shared/services/refund-creditcard-payment.service';
import { SaveCalendarDataService } from '../../services/save-calendar-data.service';
import { AmanRefundInquiryService } from 'src/app/shared/services/aman-refund-inquiry.service';
import { ContactSendOTPService } from "src/app/public-website/buyer/services/contact-send-otp.service";

@Component({
  selector: 'app-sms-marketing',
  templateUrl: './sms-marketing.component.html',
  styleUrls: ['./sms-marketing.component.scss'],
})
export class SmsMarketingComponent extends SalesComponent {
  tableColumns: string[] = [
    "productName",
    "paymentMethod",
    "status",
    "amount",
    "buyerName",
    "buyerEmail",
    "buyerMobile",
    "dateStr",
    "productType"
  ];
  displayTableColumns = {};
  oldTickets: object = {};
  curuntTicket = [];
  totalNumberOfRecords = 0;
  salesReportData: any[] = [];
  mobileNumbersArray: Array<string> = [];
  selectionModel = new SelectionModel<any>(true, []);
  filterField: any[] = [];
  selectionActions: SelectionAction[] = [];

  requestBody: Report = {};
  loading = false;
  reportName: string = '';
  productsArray: any[] = [];
  constructor(
    protected salesReportService: SalesReportService,
    protected SaveEventData: SaveEventDataService,
    protected sellerResendMailService: SellerResendMailService,
    protected translate: TranslateService,
    protected languageService: LanguageService,
    protected refundedService: RefundCreditPaymentService,
    protected amanRefundInquiryService: AmanRefundInquiryService,
    private router: Router,
    private sendMarketingSmssService: SendMarketingSmsService,
    private fetchAllSellerProductsService: FetchAllSellerProductsService,
    protected saveCalendarData: SaveCalendarDataService,
    protected sendOTPService: ContactSendOTPService,
  ) {
    super(
      salesReportService,
      SaveEventData,
      sellerResendMailService,
      translate,
      languageService,
      refundedService,
      saveCalendarData,
      amanRefundInquiryService,
      sendOTPService,
    );
  }
  async ngOnInit() {
    if (localStorage.getItem('language')) {
      if (localStorage.getItem('language') === 'ar') {
        this.loadArContent();
      } else if (localStorage.getItem('language') === 'en') {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.productsArray = await this.fetchAllSellerProductsService.make();

    this.productsArray.forEach((product) => {
      this.filterField[2].filterOptions.push({
        key: product.name,
        value: product.id,
      });
    });

    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === 'ar') {
        this.loadArContent();
      } else if (lang === 'en') {
        this.loadEnContent();
      }
      this.filterField[2].filterOptions = [];
      this.productsArray.forEach((product) => {
        this.filterField[2].filterOptions.push({
          key: product.name,
          value: product.id,
        });
      });
    });

    this.salesReportService.deactivateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }
  loadArContent() {
    this.reportName = 'تسويق بالرسائل القصيرة';
    this.translate.use('ar');

    this.displayTableColumns = {
      productName: 'المنتج',
      paymentMethod: 'طرق الدفع',
      status: 'الحالة',
      amount: 'المبلغ',
      buyerName: 'إسم المشترٍ',
      buyerEmail: 'بريد الإليكترونى المشترٍ',
      buyerMobile: 'هاتف المشترٍ',
      dateStr: 'التاريخ',
      productType: 'نوع المنتج',
    };

    this.filterField = [
      {
        filterFieldName: 'status',
        filterDisplayName: 'الحالة',
        defaultValue: '',
        filterOptions: [
          { key: 'إظهار الكل', value: null },
          { key: 'جديد', value: 'NEW' },
          { key: 'مدفوع', value: 'PAID' },
          { key: 'منتهى الصلاحية', value: 'EXPIRED' },
          { key: 'باءت بالفشل', value: 'FAILED' },
        ],
      },
      {
        filterFieldName: 'paymentMethod',
        filterDisplayName: 'طريقة الدفع',
        defaultValue: '',
        filterOptions: [
          { key: 'إظهار الكل', value: null },
          {
            key: 'النقد عن طريق فوري',
            value: paymentOptionsConstant.constantPaymentOptions.value.Fawry,
          },
          {
            key: 'بطاقة الائتمان والخصم',
            value:
              paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD,
          },
          {
            key: 'النقد عن طريق أمان',
            value: paymentOptionsConstant.constantPaymentOptions.value.CASH,
          },
          {
            key: 'محفظة الهاتف المحمول',
            value:
              paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet,
          },
          {
            key: 'ميزة',
            value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA,
          },
          {
            key: 'حر',
            value: paymentOptionsConstant.constantPaymentOptions.value.Free,
          },
          {
            key: 'بطاقة الائتمان والخصم (باي سكاي)',
            value: paymentOptionsConstant.constantPaymentOptions.value.PaySky,
          },
          {
            key: 'موجو',
            value: paymentOptionsConstant.constantPaymentOptions.value.Mogo,
          },
          {
            key: 'ترو',
            value: paymentOptionsConstant.constantPaymentOptions.value.TRU,
          },
          {
            key: 'سهوله',
            value: paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA,
          },

          {
            key: 'فاليو',
            value: paymentOptionsConstant.constantPaymentOptions.value.VALU,
          },
          {
            key: 'تقسيط امان',
            value: paymentOptionsConstant.constantPaymentOptions.value.Aman_Installments,
          },
          {
            key: 'كونتاكت',
            value: paymentOptionsConstant.constantPaymentOptions.value.Contact,
          },
          {
            key: 'حالا',
            value: paymentOptionsConstant.constantPaymentOptions.value.HALAN,
          },
          {
            key: 'تقسيط بنك اهلي',
            value: paymentOptionsConstant.constantPaymentOptions.value.NBE_GENERAL,
          },
          {
            key: 'تقسيط ٦ شهور',
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_6MONTHS,
          },
          {
            key: 'تقسيط ١٢ شهر' ,
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_12MONTHS
          },
          {
            key: 'تقسيط ١٨ شهر',
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_18MONTHS,
          },
        ],
      },
      {
        filterFieldName: 'prId',
        filterDisplayName: 'اختر منتج',
        filterOptions: [],
      },
    ];
    this.selectionActions = [
      {
        actionName: 'عدد مستقبلي الرسائل',
        actionValue: 'CANCELED',
        actionType: 'Disabled Button',
        actionClass: 'bg-white text-dark',
      },
      {
        actionName: 'إرسال رسالة تسويقية',
        actionValue: 'PAID',
        actionType: 'Button',
        actionClass: 'btn-primary',
      },
    ];
  }

  loadEnContent() {
    this.reportName = 'SMS Marketing';
    this.translate.use('en');

    this.displayTableColumns = {
      productName: 'Product',
      paymentMethod: 'Payment Method',
      status: 'Status',
      amount: 'Amount',
      buyerName: 'Buyer Name',
      buyerEmail: 'Buyer Email',
      buyerMobile: 'Buyer Mobile',
      dateStr: 'Date',
      productType: 'Product Type',
    };

    this.filterField = [
      {
        filterFieldName: 'status',
        filterDisplayName: 'Status',
        defaultValue: '',
        filterOptions: [
          { key: 'Show All', value: null },
          { key: 'New', value: 'NEW' },
          { key: 'Paid', value: 'PAID' },
          { key: 'Expired', value: 'EXPIRED' },
          { key: 'Failed', value: 'FAILED' },
        ],
      },
      {
        filterFieldName: 'paymentMethod',
        filterDisplayName: 'Payment Method',
        defaultValue: '',
        filterOptions: [
          { key: 'Show All', value: null },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.Fawry,
            value: paymentOptionsConstant.constantPaymentOptions.value.Fawry,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.CREDIT_CARD,
            value:
              paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.CASH,
            value: paymentOptionsConstant.constantPaymentOptions.value.CASH,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name
              .Mobile_Wallet,
            value:
              paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.MEEZA,
            value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.Free,
            value: paymentOptionsConstant.constantPaymentOptions.value.Free,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.PaySky,
            value: paymentOptionsConstant.constantPaymentOptions.value.PaySky,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.Mogo,
            value: paymentOptionsConstant.constantPaymentOptions.value.Mogo,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.TRU,
            value: paymentOptionsConstant.constantPaymentOptions.value.TRU,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.APPLE_PAY,
            value: paymentOptionsConstant.constantPaymentOptions.value.APPLE_PAY,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.SOUHOOLA,
            value: paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA,
          },

          {
            key: paymentOptionsConstant.constantPaymentOptions.name.VALU,
            value: paymentOptionsConstant.constantPaymentOptions.value.VALU,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.Aman_Installments,
            value: paymentOptionsConstant.constantPaymentOptions.value.Aman_Installments,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.Contact,
            value: paymentOptionsConstant.constantPaymentOptions.value.Contact,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.HALAN,
            value: paymentOptionsConstant.constantPaymentOptions.value.HALAN,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.NBE_GENERAL,
            value: paymentOptionsConstant.constantPaymentOptions.value.NBE_GENERAL,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.INSTALLMENTS_6MONTHS,
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_6MONTHS,
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_12MONTHS,
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_12MONTHS
          },
          {
            key: paymentOptionsConstant.constantPaymentOptions.name.INSTALLMENTS_18MONTHS,
            value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_18MONTHS,
          },
        ],
      },
      {
        filterFieldName: 'prId',
        filterDisplayName: 'Select a product',
        filterOptions: [],
      },
    ];
    this.selectionActions = [
      {
        actionName: 'Message Receivers',
        actionValue: 'CANCELED',
        actionType: 'Disabled Button',
        actionClass: 'bg-white text-dark',
      },
      {
        actionName: 'Send Marketing Message',
        actionValue: 'PAID',
        actionType: 'Button',
        actionClass: 'btn-primary',
      },
    ];
  }

  async selectionActionsCB(event: any) {
    this.mobileNumbersArray = event.selection.map((row) => row.buyerMobile);
    this.sendMarketingSmssService.setMobilesArray(this.mobileNumbersArray);
    this.router.navigate(['/seller/reports/create-marketing-sms']);
    try {
    } catch (err) {
      console.log(err);
    }
  }
}
